import { ClientName } from "@hopper-b2b/types";
import {
  detectBrandAttribution,
  Environment,
  getBrowserSessionId,
  isAtHotelBrand,
} from "@hopper-b2b/utilities";
// import { inspect } from "@xstate/inspect";
import { createRoot } from "react-dom/client";
import { Root } from "./Root";
import "./flights-overrides.scss";
import "./global-overrides.scss";
import "./index.scss";
import "./lodging-overrides.scss";
import * as serviceWorker from "./serviceWorker";
import config from "./utils/config";

/*
  Uncomment to use Stately visual editor:
  process.env.NODE_ENV !== "production" &&
   inspect({
     iframe: false,
   });
*/

detectBrandAttribution();

const browserSessionId = getBrowserSessionId();
const storeDomain = "hopper.com";

// Initialize Datadog Integration
import("@hopper-b2b/datadog").then(({ initialize }) =>
  initialize({
    env: config.ENV,
    version: config.REACT_APP_VERSION,
    service: ClientName.HOPPER,
    sessionId: browserSessionId,
    enableSessionRecording: true,
    allowedTracingUrls: [`${window.location.origin}/api`],
  })
);

const _sift = (window._sift = window._sift || []);
_sift.push(["_setAccount", config.SIFT_ACCOUNT]);
_sift.push(["_setTrackerUrl", "fpsb.hopper.com"]);
_sift.push(["_setSessionId", browserSessionId]);
_sift.push(["_trackPageview"]);

// Only use MOCK mode if enabled and not in production
if (config.ENV !== Environment.production && config.MOCK) {
  import("@hopper-b2b/mock").then(({ setupTenantWorker }) => {
    setupTenantWorker().start();
  });
}

// reCAPTCHA

// WAF Key
const recaptchaScript = document.createElement("script");
recaptchaScript.async = true;
recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${config.RECAPTCHA_KEY}&waf=session`;
document.head.appendChild(recaptchaScript);

// One Trust
/*
 * Disabled until we have a proper configuration. Right now this will request a script from OneTrust that will always yield a 404.
 * This is causing a console error and is generating noise in DataDog.
 *
const oneTrustScript = document.createElement("script");
oneTrustScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
oneTrustScript["data-domain-script"] = config.ONETRUST_DOMAIN_SCRIPT;
document.head.appendChild(oneTrustScript);
*/

// Riskified
const riskifiedScript = document.createElement("script");
riskifiedScript.src =
  ("https:" === document.location.protocol ? "https://" : "http://") +
  "beacon.riskified.com?shop=" +
  storeDomain +
  "&sid=" +
  browserSessionId;
riskifiedScript.async = true;
riskifiedScript.type = "text/javascript";
document.head.appendChild(riskifiedScript);

// Set AtHotel page title and favicon
if (isAtHotelBrand()) {
  document.title = "@hotel - Hopper";
  const favicon32 = document.getElementById("favicon-32x32");
  const favicon16 = document.getElementById("favicon-16x16");

  favicon16.setAttribute("href", "/athotel-favicon-16x16.png");
  favicon32.setAttribute("href", "/athotel-favicon-32x32.png");
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
